import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1b46fb56"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "component-head-box"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "alert-box"
};
var _hoisted_4 = ["onClick"];
import { ref, reactive } from 'vue';
import BuyDialog from '@/components/BuyDialog.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    isBgColor: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:isBgColor', 'linkModelShow'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var showCollModal = ref(false); // const emit = defineEmits(['update:showCollModal'])

    var pageData = reactive({
      type: 'honor',
      alertTitle: '',
      list: [{
        title: '关于我们',
        id: '#about'
      }, {
        title: '产品介绍',
        id: '#workModel'
      }, {
        title: '联系我们',
        id: '#link'
      }],
      businessType: '',
      showCollModal: false
    });

    function goAnchor(selector) {
      console.log(selector);

      if (selector === '#link') {
        emit('linkModelShow');
      } else {
        setTimeout(function () {
          document.querySelector(selector).scrollIntoView({
            behavior: "smooth"
          });
        }, 400);
      }
    }

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["head", {
          'bg-color': __props.isBgColor
        }])
      }, [_createElementVNode("img", {
        src: _ctx.$filters.addOssDomainToPath('icon/hii_logo_icon@2x.png')
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData).list, function (item, index) {
        return _openBlock(), _createElementBlock("a", {
          href: "",
          onClick: _withModifiers(function ($event) {
            return goAnchor(item.id, index);
          }, ["prevent"]),
          key: index
        }, _toDisplayString(item.title), 9, _hoisted_4);
      }), 128)), _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return showCollModal.value = true;
        })
      }, "购买软件")])])], 2), _createVNode(BuyDialog, {
        showCollModal: showCollModal.value,
        onCloseDialog: _cache[1] || (_cache[1] = function ($event) {
          return showCollModal.value = false;
        }),
        businessType: 'TP'
      }, null, 8, ["showCollModal"])]);
    };
  }
});